// extracted by mini-css-extract-plugin
export default {"doubleTableWrapper":"styles_doubleTableWrapper__5wFma"};